import React, { FC } from 'react';
import Navigation from './components/navigation';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Picture from '../@shared/picture';
import { TLightFooterProps } from './types/lightFooter.types';
import { LightFooterModel } from './models/lightFooter.model';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import SocialMedia from './components/socialMedia';
import useSitecoreContext from '../../hooks/useSitecoreContext';

const LightFooter: FC<TLightFooterProps> = (props) => {
    const model = new LightFooterModel(props);
    const {sitecoreContext} = useSitecoreContext();
    const isLogoAvailable = model.logoImage?.value?.src || model.mobileLogoImage?.value?.src;
    const isSocialMediaAvailable = model.socialLinks?.items;
    // Component is unreleased
    if (model.isUnreleased) {
        return <UnreleasedComponent />;
    }

    return (
        <>
            {model.socialLinks && <SocialMedia fields={model.socialLinks} sitecoreContext={sitecoreContext} />}
            <div className={`light-footer ${isSocialMediaAvailable ? "" : "light-footer__top-border"}`}>
                <div className="light-footer__container">
                    <div className={`light-footer__text ${isLogoAvailable ? '' : 'light-footer__text-logo'}`}>
                        <Navigation fields={model.list} />
                        {model.copyrightText && <Text tag="p" field={model.copyrightText} className="light-footer__copyright-text" />}
                    </div>
                    <Picture
                        editorialImageProps={{
                            desktopImage: model.logoImage,
                            mobileImage: model.mobileLogoImage,
                            desktopTransformation: 'Size200',
                            mobileTransformation: 'Size200',
                            cssClassPictureEl: 'light-footer__picture-logo',
                            cssClassImageEl: 'light-footer__logo',
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default LightFooter;